import(/* webpackMode: "eager" */ "/hisea-ssr/src/app/(app)/care-guide/loading.js");
